(function () {
	const _acceptButton = document.getElementById('cookie-info-accept-button');
	
	if (!_acceptButton) {
		return;
	}
	
	_acceptButton.addEventListener('click', () => {
		const date = new Date();
		date.setTime(date.getTime() + (60 * 60 * 24 * 30 * 6 * 1000));
		
		document.cookie = 'cookies_accepted=1; expires=' + date.toUTCString() + '; path=/';
		
		util.removeClass(document.getElementById('cookie-info'), 'is-visible');
	});
}());